import { render } from "./ipdUserOrderMode.vue?vue&type=template&id=b8935688"
import script from "./ipdUserOrderMode.vue?vue&type=script&lang=js"
export * from "./ipdUserOrderMode.vue?vue&type=script&lang=js"

import "./ipdUserOrderMode.vue?vue&type=style&index=0&id=b8935688&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__